import Swiper, {Lazy} from "swiper";
import SwiperCore, {Navigation, Autoplay, EffectFade,} from 'swiper';
import Animate from "../components/animate";

// install Swiper components
SwiperCore.use([Autoplay, EffectFade, Navigation, Lazy]);

class ActualNewsSlider {
    protected imgInstance;
    protected textInstance;
    protected progressSlots;
    protected progressBtn;

    protected autoplaySpeed = 7000;
    protected tickSpeed = 100;
    protected currentSlideTime: number = 0;
    protected tickInterval = null;
    protected progressBarAnimate = null;

    constructor(parentContainer) {
        this.progressBtn = $(parentContainer + ' .actual-news-slider-wrapper .progress-bar-container .progress-bar');
        this.progressSlots = $(parentContainer + ' .actual-news-slider-wrapper .progress-bar-container');

        this.textInstance = new Swiper(parentContainer + ' .actual-news-desc-slider', {
            autoplay: {
                delay: this.autoplaySpeed,
                disableOnInteraction: false,
            },
            // Disable preloading of all images
            preloadImages: false,
            // Enable lazy loading
            lazy: true,
            effect: 'fade',
            fadeEffect: {
                crossFade: true
            },
            loop: true,
            allowTouchMove: false
        });


        this.imgInstance = new Swiper(parentContainer + ' .b-actual-news-images', {
            autoplay: {
                delay: this.autoplaySpeed,
                disableOnInteraction: false,
            },
            // Disable preloading of all images
            preloadImages: false,
            // Enable lazy loading
            lazy: true,
            loop: true,
            on: {
                init: () => {
                    this.setSlide(0);
                    //this.setFinishedProgressSlots(0);
                    //this.startProgressBar();
                },
                slideChange: (e) => {
                    this.setSlide(e.realIndex)
                }
            },
            navigation: {
                nextEl: ".b-actual-news-images .btn-next",
                prevEl: ".b-actual-news-images .btn-prev"
            }
        });

        this.progressBtn.on('click', (e) => {
            e.preventDefault();
            const slideIndex = +$(e.currentTarget).data('hash');
            this.imgInstance.slideToLoop(slideIndex)
        });

    }

    protected setSlide(index) {
        this.resetProgressBar();
        this.setFinishedProgressSlots(index);
        this.startProgressBar();
        this.textInstance.slideToLoop(index)
    }

    protected setFinishedProgressSlots(currentSlide) {
        //const slotPercent = Math.round(this.currentSlideTime * 100);

        const slotPercent = -this.currentSlideTime * 100;

        this.progressSlots.each((containerId, progressContainer) => {
            $(progressContainer).find('.progress-bar').each((id, element) => {
                if ($(element).hasClass('progress-no-animate')) {
                    return;
                }

                if (id < currentSlide) {
                    $(element)
                        .find('.progress-line')
                        .css({transform: 'translateX(0%)'})
                } else {
                    $(element)
                        .find('.progress-line')
                        .css({transform: 'translateX(-100%)'})
                }

                if (id == currentSlide) {
                    $(element)
                        .addClass('running')
                        .find('.progress-line')
                        .css({transform: `translateX(${slotPercent}%)`})
                } else {
                    $(element).removeClass('running')
                }
            })
        })
    }

    protected startProgressBar() {
        this.currentSlideTime = 0;
        this.progressBarAnimate = new Animate({
            duration: this.autoplaySpeed,
            draw: (progress) => {
                this.progressSlots.each((id, el) => {
                    $(el).find('.running .progress-line').css({transform: `translateX(${-(100 - (100 * progress))}%)`})
                });
            }
        });
    }

    protected resetProgressBar() {
        this.currentSlideTime = 0;
      //  this.progressBarAnimate.cancel()
    }
}

export default ActualNewsSlider;
